import Alpine from 'alpinejs';
import hljs from 'highlight.js/lib/core';
import twig from 'highlight.js/lib/languages/twig';
import 'highlight.js/styles/base16/dracula.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { gsapHorizontalLoop } from './components/gsapHorizontalLoop';

hljs.registerLanguage('twig', twig);

// Components
gsap.registerPlugin(ScrollTrigger, SplitText);

// Entry previews scroll inside their own box, so scroll-driven components use it as their scroller
const previewScroller = document.querySelector('[data-preview-scroller]');
if (previewScroller) ScrollTrigger.defaults({ scroller: previewScroller });

// Global
window.Alpine = Alpine;
window.hljs = hljs;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.gsapHorizontalLoop = gsapHorizontalLoop;
window.SplitText = SplitText;

// Keyboard shortcut: "/" focuses the component search (unless already typing)
document.addEventListener('keydown', (event) => {
    if (event.key !== '/') return;

    const activeEl = document.activeElement;
    const isTyping =
        activeEl &&
        (activeEl.tagName === 'INPUT' ||
            activeEl.tagName === 'TEXTAREA' ||
            activeEl.isContentEditable);
    if (isTyping) return;

    const search = document.querySelector('input[name="query"]');
    if (!search) return;

    event.preventDefault();
    search.focus();
    search.select();
});

// Inits
Alpine.start();
hljs.highlightAll();